import React from 'react';
import Header from '../../../components/header';
import Timeline from './timeline';

import { useLanguage } from '../../../helpers/language-context';
import { renderHTML } from '../../../helpers/render-html';


const OurHistory = () => {
  const { translations } = useLanguage();
  return (
    <div className="ourbrand-container">
      <Header title={translations.about.ourHistory} flip={true} bgImg="/assets/images/header-bg/bg_ourhistory_new.jpg" />
      <section className="bg-white text-black space-y-16">
        <div className="flex flex-col space-y-8 justify-center items-start mx-auto">
          <div>
            <h2 className="text-[#28357B] text-4xl md:text-5xl lg:text-6xl" dangerouslySetInnerHTML={renderHTML(translations.about.ourHistoryTitle)} />
          </div>
          <div className="space-y-2 md:max-w-[80%]">
            <p className="text-md" dangerouslySetInnerHTML={renderHTML(translations.about.ourHistoryDesc)} />
          </div>
        </div>
        <Timeline />
      </section>
    </div>
  );
};

export default OurHistory;
